import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage, Field } from 'formik';
import CustomSelect from '../../../home/collections/CustomSelect';
import {
  checkFieldTypeAndPrepareRuleOptions,
  saveRuleUtil,
  showSaveButtonValidationUtil,
} from './validation-util';
import { iconForField } from '../../../../common/custom/icon-library';
import { renderInfoIcon } from '../../../common/FormFieldWithLabel';
import { FieldTypes } from 'drapcode-constant';

export default class ValidationRuleForm extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
    rule: PropTypes.object.isRequired,
    collections: PropTypes.object.isRequired,
    fields: PropTypes.array.isRequired,
    fieldOptions: PropTypes.array.isRequired,
    setFieldValue: PropTypes.func,
    setFieldTouched: PropTypes.func,
  };

  state = {
    selectedField: null,
    selectedFieldError: '',
    selectedRule: null,
    selectedRuleError: '',
    selectedRuleValueText: '',
    selectedRuleValueBoolean: false,
    selectedRuleValueError: '',
    selectedRuleMessage: '',
    selectedRuleMessageError: '',
  };

  customSelectHandleChange = (name, value) => {
    if (
      name[0] === 'selectedRule' &&
      ['required', 'validPhoneNumber', 'slug'].includes(value.value)
    ) {
      this.setState({ selectedRuleValueBoolean: true });
    } else {
      this.setState({ selectedRuleValueBoolean: false });
    }
    this.setState({
      [name]: value,
      selectedFieldError: '',
      selectedRuleError: '',
      selectedRuleValueError: '',
      selectedRuleMessageError: '',
    });
  };

  handleInputChange = ({ target: { name, value, type, checked } }) => {
    const finalValue = type === 'checkbox' ? checked : value;
    if (name === 'selectedRuleValueText') {
      this.setState({
        selectedRuleValueText: finalValue,
        selectedRuleValueBoolean: false,
        selectedFieldError: '',
        selectedRuleError: '',
        selectedRuleValueError: '',
        selectedRuleMessageError: '',
      });
    } else if (name === 'selectedRuleValueBoolean') {
      this.setState({
        selectedRuleValueBoolean: finalValue,
        selectedRuleValueText: '',
        selectedFieldError: '',
        selectedRuleError: '',
        selectedRuleValueError: '',
        selectedRuleMessageError: '',
      });
    } else {
      this.setState({
        [name]: finalValue,
        selectedFieldError: '',
        selectedRuleError: '',
        selectedRuleValueError: '',
        selectedRuleMessageError: '',
      });
    }
  };

  removeRule = () => {
    this.props.removeRule(this.props.rule.id);
  };

  saveRule = () => {
    const { rule } = this.props;
    const response = saveRuleUtil(this.props, this.state);
    const status = response.status;
    delete response['status'];
    if (status === 'ERROR') {
      this.setState(response);
    } else {
      this.props.saveValidationRule(rule.id, response);
    }
  };

  showSaveButton = () => {
    const showButton = showSaveButtonValidationUtil(this.props, this.state);
    if (showButton) {
      return this.props.saveSingleRule == true ? (
        <button onClick={this.saveRule} type="button" className="btn btn-theme-submit btn-md">
          <i className="wb webconnect-plus"></i>&nbsp;Save
        </button>
      ) : (
        <button onClick={this.saveRule} type="button" className="btn btn-sm btn-theme-submit">
          <i className="wb webconnect-save-regular"></i>&nbsp;Save
        </button>
      );
    }
  };

  showRuleValueMessage = () => {
    const {
      selectedRule,
      selectedRuleValueError,
      selectedRuleValueBoolean,
      selectedRuleValueText,
    } = this.state;
    if (selectedRule && selectedRule.value) {
      const { value } = selectedRule;
      if (
        [
          'email',
          'integer',
          'digits',
          'alphanum',
          'unique',
          'url',
          'passwordCapitalLetter',
          'passwordLowerLetter',
          'passwordNumber',
          'passwordSpecialCharacter',
          'pattern_alphabets_only',
          'pattern_numbers_only',
          'pattern_alphanumeric',
          'pattern_alphanumeric_whitespaces',
          'pattern_alphanumeric_underscores',
        ].includes(value)
      ) {
        console.log('Show chcekbox');
        return (
          <div className="col-md-6 col-lg-6 col-sm-6 col-xs-12">
            <div className="form-group">
              <div className="input-group">
                <div className="input-group-prepend" title="Required">
                  <span className="input-group-text">
                    <i className={`wb ${iconForField('boolean-toggle')}`}></i>
                    <span className="required"> *</span>
                  </span>
                </div>

                <div className="form-check">
                  <label className="form-check-label pb-12">
                    <Field
                      type="checkbox"
                      name="selectedRuleValueBoolean"
                      className="form-check-input"
                      checked={selectedRuleValueBoolean}
                      onChange={this.handleInputChange}
                    />
                    Enable Required
                    <span className="form-check-sign">
                      <span className="check"></span>
                    </span>
                  </label>
                  <ErrorMessage name="selectedRuleValueBoolean">
                    {(msg) => <p className="text-error">{msg}</p>}
                  </ErrorMessage>
                </div>
              </div>
            </div>
          </div>
        );
      } else if (['required', 'validPhoneNumber', 'slug'].includes(value)) return '';
      else {
        return (
          <div className="col-md-6 col-lg-6 col-sm-6 col-xs-12">
            <div className="form-group">
              <div className="input-group">
                <div className="input-group-prepend" title="Enter Selected Rule Value">
                  <span className="input-group-text">
                    <i className={`wb ${iconForField('text')}`}></i>
                    <span className="required"> *</span>
                  </span>
                </div>
                <input
                  type="text"
                  name="selectedRuleValueText"
                  className="form-control form-control-sm"
                  placeholder="Enter Selected Rule Value"
                  value={selectedRuleValueText}
                  onChange={this.handleInputChange}
                />
                {selectedRuleValueError && <p className="text-error">{selectedRuleValueError}</p>}
              </div>
            </div>
          </div>
        );
      }
    }
  };

  showRuleForField = (setFieldValue, setFieldTouched) => {
    const { selectedField, selectedRule, selectedRuleError } = this.state;
    if (selectedField && selectedField.value) {
      const ruleOptions = checkFieldTypeAndPrepareRuleOptions(
        this.props.fields,
        selectedField.value,
      );
      return (
        <div className="col-md-6 col-lg-6 col-sm-6 col-xs-12">
          <div className="form-group">
            <div className="input-group">
              <div className="input-group-prepend" title="Select Rule">
                <span className="input-group-text">
                  <i className={`wb ${iconForField('select')}`}></i>
                  <span className="required"> *</span>
                </span>
              </div>
              <CustomSelect
                name="selectedRule"
                isMulti={false}
                value={selectedRule}
                options={ruleOptions}
                onChangeValue={this.customSelectHandleChange}
                onChange={setFieldValue}
                onBlur={setFieldTouched}
                placeholder="Select Rule"
              />
              {selectedRuleError && <p className="text-error">{selectedRuleError}</p>}
            </div>
          </div>
        </div>
      );
    }
  };

  render() {
    const { setFieldValue, setFieldTouched, fieldOptions } = this.props;
    const {
      selectedField,
      selectedFieldError,
      selectedRule,
      selectedRuleMessage,
      selectedRuleMessageError,
    } = this.state;
    const isFileField = selectedField && selectedField.type === FieldTypes.file.id;
    const fieldNameDivClass = isFileField
      ? 'col-md-11 col-lg-11 col-sm-11 col-xs-10'
      : 'col-md-12 col-lg-12 col-sm-12 col-xs-12';
    return (
      <Fragment>
        <div className="col-md-6 col-lg-6 col-sm-6 col-xs-12 row">
          <div className={fieldNameDivClass}>
            <div className="form-group">
              <div className="input-group">
                <div className="input-group-prepend" title="Select Field">
                  <span className="input-group-text">
                    <i className={`wb ${iconForField('text')}`}></i>
                    <span className="required"> *</span>
                  </span>
                </div>
                <CustomSelect
                  name="selectedField"
                  isMulti={false}
                  value={selectedField}
                  options={[
                    ...fieldOptions.map((field) => {
                      return { label: field.label, value: field.value, type: field.type };
                    }),
                  ]}
                  onChangeValue={this.customSelectHandleChange}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  placeholder="Field"
                />
                {selectedFieldError && <p className="text-error">{selectedFieldError}</p>}
              </div>
            </div>
          </div>
          {isFileField && (
            <div className="col-md-1 col-lg-1 col-sm-1 col-xs-2">
              {renderInfoIcon(
                'File Type Field Validation',
                'File field validation isn’t supported File Upload Component',
              )}
            </div>
          )}
        </div>
        {this.showRuleForField(setFieldValue, setFieldTouched)}
        {this.showRuleValueMessage()}
        {selectedRule && selectedRule.value && (
          <div className="col-md-6 col-lg-6 col-sm-6 col-xs-12">
            <div className="form-group">
              <div className="input-group">
                <div className="input-group-prepend" title="Enter Selected Rule Message">
                  <span className="input-group-text">
                    <i className={`wb ${iconForField('text')}`}></i>
                    <span className="required"> *</span>
                  </span>
                </div>
                <input
                  type="text"
                  name="selectedRuleMessage"
                  className="form-control form-control-sm"
                  placeholder="Enter Selected Rule Message"
                  value={selectedRuleMessage}
                  onChange={this.handleInputChange}
                />
                {selectedRuleMessageError && (
                  <p className="text-error">{selectedRuleMessageError}</p>
                )}
              </div>
            </div>
          </div>
        )}
        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 text-right">
          {this.props.removeRule == false ? (
            ''
          ) : (
            <button onClick={this.removeRule} type="button" className="btn btn-sm btn-theme-delete">
              <i className="wb webconnect-trash-regular"></i>&nbsp;Remove
            </button>
          )}
          &nbsp;
          {this.showSaveButton()}
        </div>
      </Fragment>
    );
  }
}
